var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4769 18.0098C29.1395 18.0098 29.501 17.7186 29.501 17.0196V11.9905C29.501 11.2914 29.1395 11.0002 28.4769 11.0002H18.5007V1.00006C18.5007 0.359282 18.1995 0.00976562 17.4766 0.00976562H12.5248C11.8019 0.00976562 11.5007 0.359282 11.5007 1.00006V11.0002H1.50066C0.838008 11.0002 0.476562 11.2914 0.476562 11.9905V17.0196C0.476562 17.7186 0.838008 18.0098 1.50066 18.0098H11.5007V28.01C11.5007 28.6507 11.8019 29.0002 12.5248 29.0002H17.4766C18.1995 29.0002 18.5007 28.6507 18.5007 28.01V18.0098H28.4769Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.6592b168f393741f381e37007385214f.svg";
export { ForwardRef as ReactComponent };